module.exports = __webpack_public_path__ + "media/images/application/template/email-bc0075c0095c9e2f21fa2d339fb248d9.svg";